/* eslint-disable no-mixed-spaces-and-tabs */
import {
	LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT_SUCCESS, TOKEN_VALID, TOKEN_INVALID, UPDATE_LOGIN, REDIRECT_PATH_SET, redirectPathSet
} from '../Actions/LoginActions';

// The auth reducer. The starting state sets authentication
// based on a token being in local storage. In a real app,
// we would also want a util to check if the token is expired.
export const auth = (state = {
	isFetching: false,
	isAuthenticated: false,
	accountId: localStorage.getItem('accountId') || null,
	isAdmin: JSON.parse(localStorage.getItem('isAdmin')) || false,
	isSuperman: JSON.parse(localStorage.getItem('isSuperman')) || false,
	isEventCreator: JSON.parse(localStorage.getItem('isEventCreator')) || false,
	userId: localStorage.getItem('userId') || "",
	accessCode: "",
	redirectPath: false
	
}, action) => {
	switch (action.type) {
	case LOGIN_REQUEST:
		return Object.assign({}, state, {
			isFetching: true,
			isAuthenticated: false,
			user: action.creds
		});
	case LOGIN_SUCCESS:
		return Object.assign({}, state, {
			isFetching: false,
			isAuthenticated: true,
			accountId: action.accountId,
			errorMessage: '',
			isAdmin: JSON.parse(action.isAdmin),
			isSuperman: JSON.parse(action.isSuperman),
			isEventCreator: JSON.parse(action.isEventCreator),
			userId: action.userId,
			accessCode: action.accessCode
		});
	case LOGIN_FAILURE:
		return Object.assign({}, state, {
			isFetching: false,
			isAuthenticated: false,
			errorMessage: action.message
		});
	case LOGOUT_SUCCESS:
		return Object.assign({}, state, {
			isFetching: true,
			isAuthenticated: false,
			accountId: null,
			errorMessage: '',
			isAdmin: false,
			isSuperman: false,
			isEventCreator: false,
			userId: ""
		});
	case UPDATE_LOGIN:
		return Object.assign({}, state, {
			userId: action.userId,
			isAdmin: action.isAdmin,
			isSuperman: action.isSuperman,
		    accountId: action.accountId,
			accessCode: action.accessCode,
			firstName: action.firstName,
			lastName: action.lastName,
			isEventCreator: action.isEventCreator
		});
	case TOKEN_VALID:
		return Object.assign({}, state, {
			isAuthenticated: action.isAuthenticated,
			id_token: action.id_token
		});
	case TOKEN_INVALID:
		return Object.assign({}, state, {
			isAuthenticated: false
		});
	case REDIRECT_PATH_SET:
		return Object.assign({}, state, redirectPathSet(action.redirectPath));
	default:
		return state;
	}
};



// WEBPACK FOOTER //
// ./src/Store/Reducers/LoginReducer.js